import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { useRoutingInfo } from "../../context/RoutingInfoContext"
import { Steps } from "../journey/step-library"

const ViewName = Steps.ITS_A_MATCH_DECISION
export default function ItsAMatchDecisionStep(): JSX.Element {
  const { routingData } = useRoutingInfo()
  const doAnyApplyValue = routingData?.doAnyApply

  const memberSelectsValue = doAnyApplyValue && doAnyApplyValue.length ? "URGENT" : "NON_URGENT"

  const { setNextStep } = useStateMachine(ViewName, memberSelectsValue)
  useEffect(() => {
    setNextStep(ViewName, memberSelectsValue)
  })

  return <></>
}
